import React from "react";
import { useLang } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function Problem() {
  const { t } = useLang();
  const c = t.problem;
  return (
    <section id="problema" data-testid="problem-section" className="bg-olive text-ivory py-24 sm:py-32">
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-y-10 gap-x-6 mb-16">
          <Reveal className="col-span-12 lg:col-span-3 flex items-start gap-4">
            <span className="block h-px w-12 bg-terracotta mt-3" aria-hidden />
            <span className="eyebrow">{c.eyebrow}</span>
          </Reveal>
          <Reveal as="h2" className="col-span-12 lg:col-span-9 h-section">
            {c.title}
          </Reveal>
          <Reveal className="col-span-12 lg:col-span-8 lg:col-start-4">
            <p className="text-lg text-ivory/75 leading-relaxed">{c.intro}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-ivory/15">
          {c.items.map((it, idx) => (
            <Reveal
              key={it.n}
              delay={idx * 70}
              data-testid={`problem-card-${idx}`}
              className="bg-olive p-8 sm:p-12"
            >
              <div className="mb-6 big-num text-6xl text-terracotta">{it.n}</div>
              <h3 className="font-display text-2xl sm:text-3xl mb-4 leading-tight">{it.title}</h3>
              <p className="text-ivory/75 leading-relaxed">{it.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
